import { notification } from 'antd';

const errorHandler = (error) => {
	const defaultMsg = error?.response?.data?.message || error?.response?.data?.responseMessage || error?.errorFields?.[0]['errors'];
	const msg = defaultMsg || error.message || 'Something went wrong!';

	notification.error({
		message: 'Failed',
		description: msg,
		placement: 'topRight'
	});
};

export default errorHandler;
